import { useEffect } from "react";
import { api, API } from "@/lib/api";

// Try to load the company logo and use it as the favicon.
// Public endpoint /api/company/logo requires auth, so we fetch as blob then
// convert to object URL that the <link rel=icon> element can point at.
export default function FaviconLoader() {
  useEffect(() => {
    let objectUrl;
    let cancelled = false;
    async function apply() {
      try {
        const res = await api.get("/company/logo", { responseType: "blob" });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        const link = document.getElementById("app-favicon") || document.createElement("link");
        link.id = "app-favicon";
        link.rel = "icon";
        link.type = res.data.type || "image/png";
        link.href = objectUrl;
        if (!link.parentNode) document.head.appendChild(link);
      } catch {
        // No logo yet — keep default favicon.
      }
    }
    apply();
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, []);
  return null;
}

// Also export a plain URL builder for anyone who needs it.
export const companyLogoUrl = `${API}/company/logo`;
